// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalSecurity = {
  securityRiskLockEnabled: "启用风险锁定",
  securityRiskLockThreshold: "锁定触发阈值",
  securityRiskLockMinutes: "锁定时长（分钟）",
  securitySmsEnabled: "启用短信验证码",
  securitySmsScope: "短信验证码范围",
  securityOptionDisabled: "关闭",
  securityOptionLogin: "登录验证",
  securityOptionHighRisk: "高风险操作",
  securityOptionAdminLogin: "管理员登录",
  securityCaptchaEnabled: "启用图形验证码",
  securityCaptchaFailThreshold: "连续失败触发阈值",
  securityIpPolicyMode: "IP 策略模式",
  securityOptionAllowlist: "白名单",
  securityOptionBlocklist: "黑名单",
  securityIpAllowlist: "IP 白名单",
  securityIpBlocklist: "IP 黑名单",
  securitySyncHostAllowlist: "同步域名白名单",
  securityLoginRateLimit: "登录限流（次/分钟）",
  securityVerificationRateLimit: "验证码限流（次/分钟）",
  securityTitle: "安全策略",
  securitySubtitle: "维护短信验证码、图形验证码、IP 黑白名单、限流与风险拦截策略。",
  securityNotice: "在这里统一维护短信验证码、图形验证码、IP 黑白名单、登录限流与风险拦截策略。",
} as const;
